import { Box, Text } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { observer } from 'mobx-react'

import TooltipWrapper from 'modules/shift_management/components/ShiftManagement/TooltipWrapper'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { Shift } from 'modules/shift_management/lib/types'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

import DailyShiftDetails from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/ShiftCell/BaseShift/ShiftLayout/DailyShiftDetails'
import ShiftTime from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/ShiftCell/BaseShift/ShiftLayout/ShiftDetails/ShiftTime'
import ShiftTitle from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/ShiftCell/BaseShift/ShiftLayout/ShiftDetails/ShiftTitle'
import { useFormatDates } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/ShiftCell/BaseShift/ShiftLayout/ShiftDetails/utils'

export interface CompactViewProps {
  shift: Shift
  date: moment.Moment
  plannedBreaks: PlannedBreak[]
}

const CompactView = ({ shift, date, plannedBreaks }: CompactViewProps) => {
  const [{ view }] = useSchedule()
  const formatDates = useFormatDates()
  const dates = formatDates(shift, date, false)
  const time = `${dates.startAt} - ${dates.endAt} (${shift.formattedDuration(plannedBreaks)})`
  const hasNameOrTemplateTitle = !!shift.displayName

  return (
    <Box flexDirection="column" gap="s2" minWidth="s40">
      <TooltipWrapper
        visible={hasNameOrTemplateTitle}
        label={
          <>
            <Text.Normal size="100">{shift.displayName}</Text.Normal>
            <Text.Normal size="100">{time}</Text.Normal>
          </>
        }
      >
        {view.isDaily ? (
          <DailyShiftDetails
            shift={shift}
            templateTitle={shift.displayName}
            date={date}
            plannedBreaks={plannedBreaks}
          />
        ) : (
          <Box>
            {hasNameOrTemplateTitle ? (
              <ShiftTitle shift={shift} templateTitle={shift.displayName} />
            ) : (
              <ShiftTime shift={shift} date={date} plannedBreaks={plannedBreaks} />
            )}
          </Box>
        )}
      </TooltipWrapper>
    </Box>
  )
}

export default observer(CompactView)
